import React, { useContext, useEffect, useState } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { withRouter, Link, NavLink, useHistory } from 'react-router-dom';
import { Nav, NavDropdown, Navbar } from 'react-bootstrap';
import {
  DashboardIcon,
  DashboardBlueIcon,
  ClipboardIcon,
  ClipboardBlueIcon,
  PinIcon,
  ClockIcon,
  FileTextIcon,
  CheckListIcon,
  CheckListBlueIcon,
  MessageSquareIcon,
  MessageSquareBlueIcon,
  SettingIcon,
  SettingBlueIcon,
  UserIcon,
  ExportIcon,
  RecoConfigIcon
} from './Icons';
import EnableFeature from '../EnableFeature/EnableFeature';
import styled from 'styled-components';
import * as authActions from '../../actions/auth/actions';
import { getConstants } from '../../actions/constants';
import { Deliveries, Incoming, CohortsIcon, CampaignsIcon } from '../../pages/RadAdmin/Messages/Icons'
import { ReactComponent as TemplateIcon } from '../../assets/TemplateIcon.svg';
import Logo from '../UI/Logo/Logo';
import { getFixedAttributes, getFixedOptions, getLocations, getRadiologists, getTwilioConfig, getUsers, updateProvider } from '../../actions/radminUploads';
import { loadUserInfo } from '../../actions/auth';

import { Header, Brand, HeaderContainer } from './styles';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import SendIcon from '@material-ui/icons/Send';
import TipsAndUpdatesIcon from '@material-ui/icons/EmojiObjects';
import { ReactComponent as SearchReportIcon } from '../../assets/searchReportIcon.svg'
import { ReactComponent as ActivityIcon } from '../../assets/activityIcon.svg'
import { ReactComponent as BellIcon } from '../../assets/bell-icon.svg'
import { ReactComponent as RecoCohortIcon } from '../../assets/reco-cohort-icon.svg'
import { ReactComponent as RejectedRecoIcon } from '../../assets/rejected-reco-icon.svg'
import { ReactComponent as AdminSettingsIcon } from '../../assets/admin-settings-icon.svg'
import { ReactComponent as LogoutIcon } from '../../assets/logout-icon.svg'


import { Popover } from '@material-ui/core';
import ChangeLog from '../../pages/RadAdmin/Changelog';
import { AppResetContext } from '../../App';


const NavText = styled.span`
  margin-left: 5px;
`
const ProviderName = styled.div`
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 0px;
  color: #FFFFFF;
  margin-right:0.5rem;
  white-space: nowrap;
  text-align:end;
`
const CustomStyledNavDropdown = styled(NavDropdown)`
  .dropdown-toggle::after {
    color: #fff; /* Custom color for the dropdown arrow */
  }
`;

const AccountInfoContainer = styled.div`
text-align:end;
& #basic-nav-dropdown {
padding:0px;
}
`

function fullName(user) {
  let name;

  if (!user.first_name && !user.last_name) {
    name = user.email;
  }


  if (user.first_name) {
    name = user.first_name;
  }

  if (user.last_name) {
    name += ' ';
    name += user.last_name;
  }

  return name;
}
const NavDropdownMessage = ({ isClicked }) => isClicked ? (<> <MessageSquareBlueIcon /> Messages </>) : (<> <MessageSquareIcon /> Messages</>)
const NavDropdownSetting = ({ isClicked }) => isClicked ? (<> <SettingBlueIcon /> Settings</>) : (<> <SettingIcon /> Settings</>)
const NavDropdownFollowUp = ({ isClicked }) => isClicked ? (<><CheckListBlueIcon /> Follow-Ups</>) : (<><CheckListIcon /> Follow-Ups</>)
const NavDropdownOverview = ({ isClicked }) => isClicked ? (<><DashboardBlueIcon /> Overview</>) : (<><DashboardIcon /> Overview</>)

function HorizontalNavbar({ logout, user }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const featureFlags = useSelector(state => state.constants.featureFlags);
  const recoConfigData = useSelector((state) => state.radAdmin.recoConfig.data);
  const providersDataList = useSelector(state => state.radAdmin.providersList.data)?.filter(itm => !itm.is_current_provider);


  const isDoctor = user?.role === 'doctor';
  const isRadmin = user?.role === 'radiology_admin';
  const isHaveUploads = user?.isHaveUploads;
  // const navDropdownMessage = (<> <MessageSquareIcon /> Messages</>);
  // const navDropdownSetting = (<> <SettingIcon /> Settings</>);

  const [isOverViewClicked, setIsOverViewClicked] = useState(false);
  const [isQualityMetricsClicked, setIsQualityMetricsClicked] = useState(false);
  const [isfollowUplistClicked, setIsfollowUplistClicked] = useState(false);
  const [isMessagesClicked, setIsMessagesClicked] = useState(false);
  const [isSettingsClicked, setIsSettingsClicked] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [hasNewNotifications, setHasNewNotifications] = useState(user?.new_changelogs_count > 0)
  const { handleSwitchProvider } = useContext(AppResetContext)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setHasNewNotifications(false)
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  const overviewClickAnalytic = () => {
    window.analytics.track('Overview-Navigation-Click');
  }

  const viewActivityClickAnalytic = () => {
    window.analytics.track('View-Activity-Logs-Click');
  }

  const viewCustomReportsClickAnalytic = () => {
    window.analytics.track('View-Custom-Charts-Navigation-Click');
  }

  const dashboardClickAnalytic = () => {
    window.analytics.track('Dashboard-Navigation-Click');
  }
  const reportsClickAnalytic = () => {
    window.analytics.track('Reports-Navigation-Click');
  }
  const appointmentsClickAnalytic = () => {
    window.analytics.track('Appointments-Navigation-Click');
  }
  const searchClickAnalytic = () => {
    window.analytics.track('Search-Navigation-Click');
  }
  const followUpListClickAnalytic = () => {
    window.analytics.track('FollowUpList-Navigation-Click');
  }
  const patientViewListClick = () => {
    window.analytics.track('Patient-List-Navigation-Click');
  }
  const searchReportTextViewClick = () => {
    window.analytics.track('Search-Report-Text-Navigation-Click');
  }
  const integrationsClickAnalytic = () => {
    window.analytics.track('Integrations-Navigation-Click');
  }

  const refDoctorsClickAnalytic = () => {
    window.analytics.track('Ref-Doctors-Navigation-Click');
  }

  const messagesClickAnalytics = () => {
    window.analytics.track('Messages-Navigation-Click');
  }
  const campaignsClickAnalytics = () => {
    window.analytics.track('Campaigns-Navigation-Click');
  }

  const previousUploadsClickAnalytic = () => {
    window.analytics.track('Previous-Uploads-Navigation-Click');
  }

  const notesClickAnalytic = () => {
    window.analytics.track('Nav: clicked Notes navbar');
  }

  const supportClickAnalytic = () => {
    window.analytics.track('Support-Navigation-Click');
  }

  const settingsClickAnalytic = () => {
    window.analytics.track('Settings-Navigation-Click');
  }

  const exportsClickAnalytic = () => {
    window.analytics.track('Exports-Navigation-Click');
  }

  const recoConfigClickAnalytic = () => {
    window.analytics.track('Reco-Config-Navigation-Click');
  }



  const rejectedRecommendationsClickAnalytic = () => {
    window.analytics.track('Rejected-Recommendations-Navigation-Click');
  }

  const cohortsClickAnalytic = () => {
    window.analytics.track('Cohorts-Navigation-Click');
  }

  const incomingClickAnalytic = () => {
    window.analytics.track('Incoming-Navigation-Click');
  }

  const deliveriesClickAnalytic = () => {
    window.analytics.track('Deliveries-Navigation-Click');
  }





  useEffect(() => {
    dispatch(loadUserInfo());
    dispatch(getConstants());
    dispatch(getFixedOptions());
    dispatch(getFixedAttributes());
    dispatch(getLocations());
    dispatch(getRadiologists());
    dispatch(getUsers());
    dispatch(getTwilioConfig());

  }, []);

  if (!featureFlags.length) {
    return null;
  }
  return (
    <HeaderContainer>
      <Header headerStyles={recoConfigData?.provider?.navbar_style}>
        {/* <Brand> */}
        <Logo logoSource={recoConfigData?.provider?.logo} />
        {/* </Brand> */}
        <Navbar expand='lg'>
          {isRadmin && (

            <Nav defaultActiveKey='/home' className='justify-content-center'>
              <NavDropdown style={{

                "--dropdown-color": recoConfigData?.provider?.navbar_style?.link_color ?? "#ffffff",
                "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#00aeef",
                "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#fff",

              }} className="my-dropdown-item"
                title={<NavDropdownOverview isClicked={isOverViewClicked} />}>
                <NavDropdown.Item
                  className="my-dropdown-item"
                  style={{
                    "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                    "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                    "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                  }} as={NavLink}
                  eventKey='link-1'
                  to={isHaveUploads ? '/auth/radAdmin/Overview' : '/auth/radAdmin/Dashboard'}
                  onClick={overviewClickAnalytic}

                >
                  <DashboardIcon /> Overview
                </NavDropdown.Item>
                <EnableFeature featureName={'enable-custom-charts'}>
                  <NavDropdown.Item
                    className="my-dropdown-item"
                    style={{
                      "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                      "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                      "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                    }}
                    as={NavLink}
                    eventKey='link-16'
                    to={'/auth/radAdmin/custom/charts/view'}
                    onClick={viewCustomReportsClickAnalytic}

                  >
                    {isOverViewClicked ? <CampaignsIcon /> : <CampaignsIcon />} Custom Charts
                  </NavDropdown.Item>
                </EnableFeature>

                <NavDropdown.Item
                  as={NavLink}
                  eventKey='link-17'
                  to={'/auth/radAdmin/activity?tab=recommendations'}
                  onClick={viewActivityClickAnalytic}
                  className="my-dropdown-item"
                  style={{
                    "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                    "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                    "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                  }}
                >
                  {<ActivityIcon />} Activity Logs
                </NavDropdown.Item>
              </NavDropdown>
              <EnableFeature featureName={'ref-docs-list-view'}>
                <Nav.Link
                  className="my-dropdown-item"
                  style={{
                    "--dropdown-color": recoConfigData?.provider?.navbar_style?.link_color ?? "#ffffff",
                    "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#00aeef",
                    "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#fff",

                  }}
                  as={NavLink}
                  eventKey='link-2'
                  to='/auth/radAdmin/referringDocs'
                  onClick={refDoctorsClickAnalytic}

                >
                  <ClipboardIcon /> <NavText isClicked={isQualityMetricsClicked}>Quality Metrics</NavText>
                </Nav.Link>
              </EnableFeature>
              <EnableFeature featureName={'enable-follow-up-list-view'} onClick={followUpListClickAnalytic}>
                <NavDropdown style={{

                  "--dropdown-color": recoConfigData?.provider?.navbar_style?.link_color ?? "#ffffff",
                  "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#00aeef",
                  "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#fff",

                }} className="my-dropdown-item" title={<NavDropdownFollowUp isClicked={isfollowUplistClicked} id='basic-nav-dropdown' />}>
                  {recoConfigData && <NavDropdown.Item
                    className="my-dropdown-item"
                    style={{
                      "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                      "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                      "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                    }}
                    as={NavLink}
                    eventKey='link-10'
                    to='/auth/radAdmin/followUpList'

                  > <CheckListIcon />  Follow-Ups
                  </NavDropdown.Item>
                  }
                  <EnableFeature featureName={'enable-patient-view-list'} onClick={patientViewListClick}>
                    <NavDropdown.Item
                      className="my-dropdown-item"
                      style={{
                        "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                        "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                        "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                      }}
                      as={NavLink}
                      eventKey='link-11'
                      to='/auth/radAdmin/followUp/patients'

                    > <UserIcon />  Patients
                    </NavDropdown.Item>
                  </EnableFeature>
                  <NavDropdown.Item
                    className="my-dropdown-item"
                    style={{
                      "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                      "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                      "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                    }}
                    as={NavLink}
                    eventKey='link-12'
                    to='/auth/radAdmin/followUp/notes'

                    onClick={notesClickAnalytic}
                  > <FileTextIcon />  Notes
                  </NavDropdown.Item>
                  <EnableFeature featureName={'enable-search'} onClick={searchReportTextViewClick}>
                    <NavDropdown.Item
                      className="my-dropdown-item"
                      style={{
                        "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                        "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                        "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                      }}
                      as={NavLink}
                      eventKey='link-13'
                      to='/auth/radAdmin/followUp/search-report-text'

                    > <SearchReportIcon /> Search Report Text
                    </NavDropdown.Item>
                  </EnableFeature>


                  <EnableFeature featureName={'enable-task-list'}>
                    <NavDropdown.Item
                      className="my-dropdown-item"
                      style={{
                        "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                        "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                        "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                      }}
                      as={NavLink}
                      eventKey='link-24'
                      to='/auth/radAdmin/followUp/cohorts/?tab=recommendations'
                      // isActive={(match) => {
                      //   if(match){
                      //     setIsMessagesClicked(true);
                      //     setIsSettingsClicked(false);
                      //   }
                      //   return match
                      // }}
                      onClick={cohortsClickAnalytic}
                    >
                      <CohortsIcon /> Cohorts
                    </NavDropdown.Item>
                  </EnableFeature>
                  <EnableFeature featureName={'enable-task-list'}>
                    <NavDropdown.Item
                      className="my-dropdown-item"
                      style={{
                        "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                        "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                        "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                      }}
                      as={NavLink}
                      eventKey='link-22'
                      to='/auth/radAdmin/followUp/recommendations/rejected'
                      onClick={rejectedRecommendationsClickAnalytic}
                    >
                      <RejectedRecoIcon />Rejected Recommendations
                    </NavDropdown.Item>

                  </EnableFeature>
                </NavDropdown>

              </EnableFeature>
              {/* <EnableFeature featureName={'view-messages'}>
              <Nav.Link as={Link} eventKey='link-7' to='/auth/radAdmin/messages' onClick={messagesClickAnalytics}>
                <MessageSquareIcon /> Messages
              </Nav.Link>
            </EnableFeature> */}
              <EnableFeature featureName={'view-messages'} onClick={messagesClickAnalytics}>
                <NavDropdown style={{

                  "--dropdown-color": recoConfigData?.provider?.navbar_style?.link_color ?? "#ffffff",
                  "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#00aeef",
                  "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#fff",

                }} className="my-dropdown-item" title={<NavDropdownMessage isClicked={isMessagesClicked} />} id='basic-nav-dropdown'>
                  <NavDropdown.Item
                    className="my-dropdown-item"
                    style={{
                      "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                      "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                      "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                    }}
                    as={NavLink}
                    eventKey='link-9'
                    to='/auth/radAdmin/messages/templates'

                  >
                    <TemplateIcon /> Templates
                  </NavDropdown.Item>
                  <EnableFeature featureName={'campaign-view'} onClick={campaignsClickAnalytics}>
                    <NavDropdown.Item
                      className="my-dropdown-item"
                      style={{
                        "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                        "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                        "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                      }}
                      as={NavLink}
                      eventKey='link-10'
                      to='/auth/radAdmin/Campaigns'

                    >
                      <CampaignsIcon /> Campaigns
                    </NavDropdown.Item>
                  </EnableFeature>
                  <NavDropdown.Item
                    className="my-dropdown-item"
                    style={{
                      "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                      "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                      "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                    }}
                    as={NavLink}
                    eventKey='link-7'
                    exact
                    to='/auth/radAdmin/messages'

                    onClick={incomingClickAnalytic}
                  >
                    <Incoming /> Incoming
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="my-dropdown-item"
                    style={{
                      "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                      "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                      "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                    }}
                    as={NavLink}
                    eventKey='link-8'
                    exact
                    to='/auth/radAdmin/messages/deliveries'

                    onClick={deliveriesClickAnalytic}
                  >
                    <Deliveries /> Deliveries
                  </NavDropdown.Item>
                </NavDropdown>
              </EnableFeature>
              <NavDropdown style={{

                "--dropdown-color": recoConfigData?.provider?.navbar_style?.link_color ?? "#ffffff",
                "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#00aeef",
                "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#fff",

              }} className="my-dropdown-item" title={<NavDropdownSetting isClicked={isSettingsClicked} />} id='basic-nav-dropdown'>
                <NavDropdown.Item
                  className="my-dropdown-item"
                  style={{
                    "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                    "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                    "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                  }}
                  as={NavLink}
                  eventKey='link-4'
                  to={isHaveUploads ? '/auth/radAdmin/Import' : '/auth/radAdmin/Dashboard'}
                  onClick={integrationsClickAnalytic}

                >
                  <FileTextIcon /> Import
                </NavDropdown.Item>
                <NavDropdown.Item
                  className="my-dropdown-item"
                  style={{
                    "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                    "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                    "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                  }}
                  as={NavLink}
                  eventKey='link-5'
                  to='/auth/radAdmin/previousUploads'
                  onClick={previousUploadsClickAnalytic}

                >
                  <ClockIcon /> Previous Uploads
                </NavDropdown.Item>
                <EnableFeature featureName={'enable-export-page-view'}>

                  <NavDropdown.Item className="my-dropdown-item"
                    style={{
                      "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                      "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                      "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                    }}
                    as={Link} eventKey='link-6' to='/auth/radAdmin/exports' onClick={exportsClickAnalytic} >
                    <ExportIcon /> Exports
                  </NavDropdown.Item>
                </EnableFeature>
              </NavDropdown>

            </Nav>
          )}
        </Navbar>


        <Navbar expand="lg">

          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }} className='mr-auto'>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                {isRadmin && <div onClick={handleClick} style={{ position: 'relative' }}>
                  <BellIcon style={{ cursor: 'pointer' }} />
                  {
                    hasNewNotifications && user?.new_changelogs_count > 0 && <div style={{ background: '#00AEEF', borderRadius: '50%', width: '16px', height: '16px', position: 'absolute', top: '-50%', transform: 'translate(-50%, 50%)', right: '-85%', color: '#0C2945', fontWeight: 600, fontSize: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                      {user?.new_changelogs_count}
                    </div>
                  }
                </div>
                }
                <div>
                  <AccountInfoContainer>
                    <NavDropdown style={{

                      "--dropdown-color": recoConfigData?.provider?.navbar_style?.link_color ?? "#ffffff",
                      "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#00aeef",
                      "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.link_active_color ?? "#fff",

                    }} className="my-dropdown-item" title={recoConfigData?.name ? `${recoConfigData?.name}` : ''} id='basic-nav-dropdown' alignRight>
                      {
                        (providersDataList?.length === 0 || !providersDataList) && <NavDropdown.Header>No Other Provider Added For This User</NavDropdown.Header>
                      }

                      {providersDataList?.map(itm => <NavDropdown.Item className="my-dropdown-item"
                        style={{
                          "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                          "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                          "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                        }} onClick={() => {
                          dispatch(updateProvider(itm.id)).then(res => {
                            if (res) {
                              history.push('/auth/radAdmin/Overview');
                              handleSwitchProvider();
                            }
                          })
                        }}>{itm.name}</NavDropdown.Item>)}

                    </NavDropdown>
                  </AccountInfoContainer>

                  <AccountInfoContainer>
                    <NavDropdown style={{

                      "--dropdown-color": recoConfigData?.provider?.navbar_style?.link_color ?? "#ffffff",
                      "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#00aeef",
                      "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#fff",

                    }} className="my-dropdown-item" title={fullName(user)} id='basic-nav-dropdown' alignRight>
                      {isRadmin && <NavDropdown.Item className="my-dropdown-item"
                        style={{
                          "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                          "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                          "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                        }} as={Link} to='/auth/radAdmin/settings' onClick={settingsClickAnalytic}>
                        <AdminSettingsIcon style={{ cursor: 'pointer' }} />
                        Settings
                      </NavDropdown.Item>}
                      <NavDropdown.Item className="my-dropdown-item"
                        style={{
                          "--dropdown-color": recoConfigData?.provider?.navbar_style?.dropdown_color ?? "#000",
                          "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.dropdown_hover_color ?? "#000",
                          "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.dropdown_active_color ?? "#fff",

                        }} onClick={() => logout()}>
                        <LogoutIcon style={{ cursor: 'pointer' }} /> Log out

                      </NavDropdown.Item>
                    </NavDropdown>
                  </AccountInfoContainer>
                </div>
              </div>

            </Nav>
          </Navbar.Collapse>
          {
            isRadmin && <Nav.Link as={Link} className="my-dropdown-item"
              style={{
                "--dropdown-color": recoConfigData?.provider?.navbar_style?.link_color ?? "#ffffff",
                "--dropdown-hover-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#00aeef",
                "--dropdown-active-color": recoConfigData?.provider?.navbar_style?.link_hover_color ?? "#fff",

              }}
              to='/auth/radAdmin/support' onClick={supportClickAnalytic}>
              <HelpOutlineIcon style={{ width: "20px", height: '20px', color: '#fff' }} /> Support
            </Nav.Link>
          }
        </Navbar>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: -10,
            horizontal: 'center',
          }}
        >
          <ChangeLog />
        </Popover>

      </Header>
    </HeaderContainer>
  );
}

function mapStateToProps(state) {
  const { isLoggedIn, user } = state.auth;

  return {
    isLoggedIn,
    user
  };
}

export default withRouter(connect(mapStateToProps, authActions)(HorizontalNavbar));
